/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
// @flow
import React from 'react';

import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import MistakeItem from './MistakeItem';

type MistakesProps = {
  category: any,
  stackSize: any,
  seeRange: () => void,
  isPlo5: boolean,
  isFreeUser?: boolean,
}

const Mistakes = ({
  category, stackSize, seeRange, isPlo5, isFreeUser,
}: MistakesProps) => {
  const { mistakes } = useSelector((state) => state.game.mistakes);

  const positionMapping = {
    ep: 'EP',
    mp: 'MP',
    co: 'CO',
    bu: 'BU',
    sb: 'SB',
    sbnolimp: 'SB no limp',
    bbvssblimp: 'BB vs SB limp',
    mpvsep: 'MP vs EP',
    covsep: 'CO vs EP',
    buvsep: 'BU vs EP',
    sbvsep: 'SB vs EP',
    bbvsep: 'BB vs EP',
    covsmp: 'CO vs MP',
    buvsmp: 'BU vs MP',
    sbvsmp: 'SB vs MP',
    bbvsmp: 'BB vs MP',
    buvsco: 'BU vs CO',
    sbvsco: 'SB vs CO',
    bbvsco: 'BB vs CO',
    sbvsbu: 'SB vs BU',
    bbvsbu: 'BB vs BU',
    bbvssb: 'BB vs SB',
    bbvssbnolimp: 'BB vs SB no limp',
    sblimpvsbb: 'SB limp vs BB raise',
    epvsmp: 'EP vs MP',
    epvsco: 'EP vs CO',
    epvsbu: 'EP vs BU',
    epvssb: 'EP vs SB',
    epvsbb: 'EP vs BB',
    mpvsco: 'MP vs CO',
    mpvsbu: 'MP vs BU',
    mpvssb: 'MP vs SB',
    mpvsbb: 'MP vs BB',
    covsbu: 'CO vs BU',
    covssb: 'CO vs SB',
    covsbb: 'CO vs BB',
    buvssb: 'BU vs SB',
    buvsbb: 'BU vs BB',
    sbvsbb: 'SB vs BB',
    sbnolimpvsbb: 'SB no limp vs BB',
    'epvssqzmp+co': 'EP vs MP+CO sqz',
    'epvssqzco+bu': 'EP vs CO+BU sqz',
    'epvssqzbu+sb': 'EP vs BU+SB sqz',
    'epvssqzsb+bb': 'EP vs SB+BB sqz',
    'mpvssqzco+bu': 'MP vs CO+BU sqz',
    'mpvssqzbu+sb': 'MP vs BU+SB sqz',
    'mpvssqzsb+bb': 'MP vs SB+BB sqz',
    'covssqzbu+sb': 'CO vs BU+SB sqz',
    'covssqzsb+bb': 'CO vs SB+BB sqz',
    'buvssqzsb+bb': 'BU vs SB+BB sqz',
    'cosqzep+mp': 'CO sqz EP+MP',
    'busqzep+mp': 'BU sqz EP+MP',
    'busqzmp+co': 'BU sqz MP+CO',
    'sbsqzep+mp': 'SB sqz EP+MP',
    'sbsqzmp+co': 'SB sqz MP+CO',
    'sbsqzco+bu': 'SB sqz CO+BU',
    'bbsqzep+mp': 'BB sqz EP+MP',
    'bbsqzmp+co': 'BB sqz MP+CO',
    'bbsqzco+bu': 'BB sqz CO+BU',
    'bbsqzbu+sb': 'BB sqz BU+SB',
    'co4bvsep+mp3bet': 'CO4B vs EP+MP3BET',
    'bu4bvsmp+co3bet': 'BU4B vs MP+CO3BET',
    'sb4bvsep+mp3bet': 'SB4B vs EP+MP3BET',
    'sb4bvsco+bu3bet': 'SB4B vs CO+BU3BET',
    'bb4bvsbu+sb3bet': 'BB4B vs BU+SB3BET',
    bbvssb4bet: 'BB vs SB',
    bbvssbnolimp4bet: 'BB vs SB no limp',
    mpvsep4bet: 'MP vs EP',
    covsep4bet: 'CO vs EP',
    covsmp4bet: 'CO vs MP',
    buvsep4bet: 'BU vs EP',
    buvsmp4bet: 'BU vs MP',
    buvsco4bet: 'BU vs CO',
    sbvsep4bet: 'SB vs EP',
    sbvsmp4bet: 'SB vs MP',
    sbvsco4bet: 'SB vs CO',
    sbvsbu4bet: 'SB vs BU',
    bbvsep4bet: 'BB vs EP',
    bbvsmp4bet: 'BB vs MP',
    bbvsco4bet: 'BB vs CO',
    bbvsbu4bet: 'BB vs BU',

  };

  const mistakePosition = (position: string) => (
    `${positionMapping[position]} (${category.label})`
  );

  const isEasyRFI = category.value === 'easyrfi';

  return (
    <>
      <div className={styles.note}>
        By clicking on the hand you can see the range
      </div>
      <div className={styles.container}>
        <div>
          {
            mistakes && mistakes.map((item, idx) => (
              <React.Fragment key={`${idx}_mistake`}>
                {item && (
                <div className={styles.mistakePosition}>
                  {mistakePosition(item.position)}
                </div>
                )}
                {item && item.data.map((itemData) => (
                  <MistakeItem
                    key={itemData.combo}
                    combo={itemData.combo}
                    bb={itemData.bb}
                    answer={itemData.answer}
                    ev_c={itemData.ev_c}
                    ev_f={itemData.ev_f}
                    ev_r={itemData.ev_r}
                    stake={itemData.stake}
                    ts={itemData.ts}
                    weight_c={itemData.weight_c}
                    weight_f={itemData.weight_f}
                    weight_r={itemData.weight_r}
                    isEasyRFI={isEasyRFI}
                    easyFold={itemData.easy_fold}
                    seeRange={seeRange}
                    itemData={itemData}
                    isPlo5={isPlo5}
                    isFreeUser={isFreeUser}
                  />
                ))}
              </React.Fragment>
            ))
          }
        </div>
      </div>
    </>
  );
};

export default Mistakes;
